export const getTimeStamp = (date: Date | string, time: string | number) => {
  const localDate = new Date(
    replaceBetweenString(date.toString(), 16, 21, time.toString())
  );

  return localDate.getTime();
};

const replaceBetweenString = function (
  string: string,
  start: number,
  end: number,
  newString: string
) {
  return string.substring(0, start) + newString + string.substring(end);
};
